import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Company Short Descriptions',
  basePath: '/company-short-description',
  columns: [
    { key: 'description', label: 'Short Description', sortable: true },
  ],
  fields: [
    { key: 'description', label: 'Short Description', type: 'text' },
  ],
  defaultSort: { field: 'description', dir: 'asc' },
});
